<script>
	import { mapState, mapGetters } from "vuex";
	export default {
		computed: {
			...mapState({
				headers: state => state.billing.headers
			}),
			...mapGetters(["enabledHeaders"]),
			selectedHeaders: {
				get() {
					return Object.keys(this.enabledHeaders);
				},
				set(newValue) {
					for (const [key] of Object.entries(this.headers)) {
						if (newValue.includes(key)) {
							this.$store.commit("enableHeaderByKey", key);
						} else {
							this.$store.commit("disableHeaderByKey", key);
						}
					}
				}
			},
			displayableHeaders() {
				const _headers = { ...this.headers };

				delete _headers.designation;

				return _headers;
			}
		},
		methods: {
			toggle(event) {
				this.$refs.dropdownMain.toggle(event);
			}
		}
	};
</script>

<template>
	<b-dropdown
		id="dropdownMain"
		ref="dropdownMain"
		variant="link"
		no-caret
		class="sinao-dropdown"
	>
		<template #button-content>
			<b-icon
				icon="pencil"
				@click="toggle"
			/>
			<b-tooltip
				placement="left"
				target="dropdownMain"
				container="body"
			>	
				{{ $t("Ajouter / supprimer des colonnes") }}
			</b-tooltip>
		</template>

		<b-form-checkbox-group
			id="checkbox-group"
			v-model="selectedHeaders"
			stacked
		>
			<b-form-checkbox
				v-for="(header, index) in displayableHeaders"
				:key="index"
				:value="index"
			>
				{{ header.value }}
			</b-form-checkbox>
		</b-form-checkbox-group>
	</b-dropdown>
</template>

<style scoped lang="scss">
	.dropdown.sinao-dropdown {
		position: absolute;
		margin-left: -25px;
		top: 0;

		& .custom-checkbox {
			padding: 0;

			& ::v-deep > label {
				cursor: pointer;
			}
			&:hover {
				background-color: #ececec;
			}

			~ .custom-checkbox {
				border-top: thin solid #d6d6d6;
			}
		}

		::v-deep {
			button {
				padding: 5px 0;
				@media screen and (prefers-reduced-motion: no-preference) {
					transition: background-color 300ms ease-in-out;
				}
			}
			.custom-control-label {
				padding: 0.25em 0.25em 0.25em 1.7em;
				width: 100%;

				&::before,
				&::after {
					left: 0.4em;
					top: 0.5em;
				}
			}

			.dropdown-item {
				padding: 0;
			}

			.dropdown-menu {
				min-width: 177px;
				background: rgb(253, 253, 253);
				border: 1px solid rgb(235, 239, 242);
				box-shadow: rgba(50, 45, 40, 0.1) 0px 2px 2px,
					rgba(54, 47, 40, 0.25) 0px 6px 15px;
				border-radius: 5px;
				padding: 5px 10px;
			}
		}

		&.show ::v-deep button {
			background-color: #ececec;
		}

		.form-group {
			margin: 0;
		}
	}
</style>
